import { useCallback, useRef, useState } from 'react';
import phillyBanner from '@/assets/images/multiregional_banners_home_ae_en_1_KITOPI-PHILLY.jpg';
import goGreekBanner from '@/assets/images/multiregional_banners_home_ae_en_2_GoGreek.jpg';
import awaniBanner from '@/assets/images/multiregional_banners_home_ae_en_3_Awani.png';
import { sendBusinessEvent } from '@/screens/Checkout/monitoring';
import styles from './MarketingBanners.module.scss';

interface Banner {
  id: string;
  image: string;
  alt: string;
}

const BANNERS: Banner[] = [
  { id: 'awani', image: awaniBanner, alt: 'Awani' },
  { id: 'go-greek', image: goGreekBanner, alt: 'GO! GREEK' },
  { id: 'philly', image: phillyBanner, alt: 'Kitopi Philly' },
];

export const MarketingBanners = () => {
  const trackRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const handleScroll = useCallback(() => {
    const track = trackRef.current;
    if (!track || !track.clientWidth) return;
    // scrollLeft is negative in RTL layouts
    setActiveIndex(Math.round(Math.abs(track.scrollLeft) / track.clientWidth));
  }, []);

  return (
    <div className={styles.root} data-testid="marketing-banners">
      <div ref={trackRef} className={styles.track} onScroll={handleScroll}>
        {BANNERS.map(({ id, image, alt }, index) => (
          <div key={id} className={styles.slide} data-testid="marketing-banner">
            <img
              src={image}
              alt={alt}
              className={styles.image}
              onClick={() =>
                sendBusinessEvent('kitopay.marketing.banner.clicked', {
                  bannerId: id,
                  position: index + 1,
                })
              }
            />
          </div>
        ))}
      </div>
      <div className={styles.dots}>
        {BANNERS.map(({ id }, index) => (
          <span
            key={id}
            className={`${styles.dot} ${index === activeIndex ? styles.active : ''}`}
            data-testid="marketing-banner-dot"
            data-active={(index === activeIndex).toString()}
          />
        ))}
      </div>
    </div>
  );
};
